import { EventEmitter } from 'fbemitter'

const emiter = new EventEmitter()

export default emiter
